import { Spinner } from '@frontend/components/common';
import { ICONS, QRCode } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useOpenDropOffScanCourierTrackAndTrace from './open-drop-off-scan-courier-track-and-trace.controller';

const ID = 'open-drop-off-scan-courier-track-and-trace';

const OpenDropOffScanCourierTrackAndTrace = () => {
    const viewProps = useOpenDropOffScanCourierTrackAndTrace();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.DROP_OFF }}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitDisabled: false
            }}
            loadingModal={{ show: viewProps.resolving }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.UNRECOGNIZED_CODE,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-8 self-stretch overflow-y-scroll p-6 pb-20'>
            <div className='inline-flex items-center justify-center gap-3 self-stretch'>
                <div className='relative size-6 overflow-hidden'>
                    <QRCode className='text-always-black size-6' />
                </div>
                <div className='text-always-black justify-end text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.open-drop-off-scan-courier-track-and-trace.scan-code'
                        defaultMessage='Scan courier track and trace'
                        description='Heading on the open drop-off courier track-and-trace scan screen'
                    />
                </div>
            </div>

            <div className='h-8 w-full' />

            <div className='flex flex-col items-center gap-5'>
                <div className='text-always-black justify-end text-center text-base font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.open-drop-off-scan-courier-track-and-trace.instructions'
                        defaultMessage='Scan a courier code if you have one, or continue without scanning'
                        description='Instructions on the open drop-off courier track-and-trace scan screen'
                    />
                </div>

                {viewProps.info && <div className='text-status-success text-center text-sm font-medium'>{viewProps.info}</div>}

                <div className='bg-brand-secondary relative flex size-24 items-center justify-center rounded-full'>
                    {viewProps.resolving && <Spinner className='text-border-default fill-brand-primary size-25' />}
                    <ICONS.BUTTON.ARROW_DOWN className='text-always-white absolute size-10' />
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default OpenDropOffScanCourierTrackAndTrace;
